<template>
    <q-table
      stripe
      class="mdi-card"
      color="primary"
      row-key="id"
      selection="multiple"
      separator="horizontal"
      dense
      :resource="resource"
      :filter="filter"
      :loading="loading"
      :columns="columns"
      :data="serverData"
      @request="request"
      @selection="handleSelectionChange"
      :pagination.sync="pagination"
      :selected.sync="selectedRows"
      :rows-per-page-options="[0, 25, 50, 100, 250]"
      :visible-columns.sync="visibleColumnsSync"
    >
      <div slot="top" slot-scope="props" class="full-width q-pt-sm q-pb-sm">
        <transition
          mode="out-in"
          enter-active-class="animated flipInX"
          leave-active-class="animated flipOutX"
        >
          <!-- SEARCH -->
          <div
            v-if="!selectedRows.length"
            key="search-bar"
            class="row flex-center gutter-md"
            style="animation-duration: 0.4s"
          >
            <div class="col-6">
              <auto-saver
                :duration="900"
                :d-bounce="handleSearch"
                :value="search"
              ><q-input
                slot-scope="props"
                :loading="props.isSaving"
                :before="[{icon: 'search'}]"
                placeholder="Search all records"
                color="secondary"
                class="full-width no-shadow q-body-1"
                clearable
                v-model="search"
                hide-underline
                @keydown.esc="search=''"
              />
              </auto-saver>
            </div>
            <!-- ICONS -->
            <div class="col-3 text-right">
              <q-table-columns
                class="q-body-1 full-width"
                v-model="visibleColumnsSync"
                label="Visible Columns"
                :columns="columns"
              />
            </div>
          </div>
        </transition>
      </div>
      <filter-bar
        slot="top-row" slot-scope="props"
        :cols="props.cols"
        :resource="resource"
        @change="request({pagination: pagination})"
      />
      <template
        v-for="(column, columnIndex) in visibleColumns"
        :slot="`body-cell-${column.name}`"
        slot-scope="props"
      >
        <q-td
          :key="columnIndex"
          :align="column.align"
        >
          <grid-cell
            :column="column"
            :row="props.row"
            :id="props.row.id"
            :value="props.value"
            :resource="resource"
            :trashed="false"
            :client-route="clientRoute"
          ></grid-cell>
        </q-td>
      </template>
    </q-table>
</template>
<script>
import { extend } from 'quasar'
import colors from '../../mixins/colors'
export default {
  name: 'SelectLayoutTable',
  mixins: [colors],
  props: {
    'resource': {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      filter: '',
      ready: false,
      loading: false,
      selectedColumnsAction: null,
      selectedColumnsValue: null,
      search: '',
      selectedRows: [],
      visibleColumnsModel: null,
      pagination: { page: 1 }
    }
  },
  computed: {
    serverData () {
      return this.$store.state[this.resource].records
    },
    listLayout () {
      switch (this.layout) {
        case 'cards':
          return 'layout-cards'
        case 'accordion':
          return 'layout-accordion'
        default:
          return 'layout-table'
      }
    },
    maxPage () {
      return Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage || 1)
    },
    clientRoute () { return this.$store.state[this.resource].clientRoute },
    filters () { return this.$store.getters[`${this.resource}/filters`] },
    settings () { return this.$store.getters[`${this.resource}/settings`] },
    relations () { return this.$store.getters[`${this.resource}/relations`] },
    columns () {
      return this.$store.getters[`${this.resource}/columns`].filter(column => column.label !== 'Delete' && column.label !== 'Edit')
    },
    visibleColumns () {
      var test = this.$store.getters[`${this.resource}/visibleColumns`]
      // console.log('Visible Columns:')
      // console.log(test)
      return test
    },
    filterColumns () { return this.$store.getters[`${this.resource}/filterColumns`] },
    columnOptions () {
      return this.columns.filter(c => c.component && c.component.is)
        .map(c => {
          return {label: c.label, value: c.field}
        })
    },
    batchUpdateComponentColumn () {
      return this.columns.find(c => c.field === this.selectedColumnsAction)
    },
    visibleColumnsSync: {
      get () {
        if (this.visibleColumnsModel === null) {
          return this.visibleColumns.reduce((arr, column) => {
            if (column && column.field) {
              arr.push(column.field)
            }
            return arr
          }, [])
        }

        return this.visibleColumnsModel
      },
      set (payload) {
        this.visibleColumnsModel = payload
      }
    }
  },
  methods: {
    async handleSearch (v) {
      // console.log('search!')
      await this.request({pagination: this.pagination, filter: v})
    },
    async request ({pagination = {}, filter = ''}) {
      // console.log(pagination)
      // console.log(filter)
      this.loading = true
      try {
        await this.$store.dispatch(`${this.resource}/paginate`, {
          client: this.$axios,
          pagination,
          search: filter
        })
        this.loading = false
        return Promise.resolve()
      } catch (e) {
        this.loading = false
        return Promise.resolve()
      }
    },
    async handleSort ({field, direction}) {
      const pagination = extend(true, this.pagination, {
        sortBy: field,
        descending: direction < 0
      })
      await this.request({pagination})
    },
    async handleSelectionChange (numRows, rows) {
      // console.log('Selected Rows Changed')
      // console.log(rows)
    }
  }
}
</script>
